// import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react"
import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material'
import { isEmpty, isNil, reduce } from 'lodash/fp'
import log from 'loglevel'
import { useEffect, useState } from 'react'
// import { Outlet } from "react-router-dom"
// import { Loading } from "../Loading"
// import { UserAuthError } from "../UserAuthError"
import { Auth0Context, useAuth0 } from '@auth0/auth0-react'
import { useOutletContext } from 'react-router-dom'
import {
  EnumPaymentGmoPgStatus,
  UserOutletContext,
  SubscriptionStatus
} from '../../types'
import { Loading } from '../Loading'
import { requestGetInvoices } from '../../functions/common'
import {
  format,
  isWithinInterval,
  parse,
  setDate,
  startOfMonth,
  subDays
} from 'date-fns/fp'
import { pickMostPriorirtyLog } from '../PaymentEdit/functions'
import { ServerError } from '../ServerError'
import { inspect } from '../../inspect'

const dispRepaymentStatDate = 1
const dispRepaymentEndDate = 16

const DispPaymentSubscriptions = (props: {
  paymentSubscriptions: string[]
}) => {
  const { paymentSubscriptions } = props
  const disp = reduce((disp: string, subscription: string) => {
    return `${disp}${subscription}`
  }, '')(paymentSubscriptions)
  return <>{disp}</>
}

export const ContractConfirm = () => {
  const { user } = useAuth0(Auth0Context)
  const { memberId, subscription, paymentSubscriptions } =
    useOutletContext<UserOutletContext>()
  const [loading, setLoading] = useState<boolean>(true)
  const [hasError, setHasError] = useState<boolean>(false)
  const [invoice, setInvoice] = useState<EnumPaymentGmoPgStatus | undefined>(
    undefined
  )
  useEffect(() => {
    if (!isNil(subscription)) {
      const getInvoice = async () => {
        const invoices = await requestGetInvoices(
          subscription.zuoraAccountNo,
          user?.sub as string
        )
        if (isNil(invoices)) {
          log.error('[ContractConfirm] cannot get invoices')
          setHasError(true)
          return undefined
        }
        const current = !isEmpty(invoices)
          ? pickMostPriorirtyLog(invoices[format('yyyy-MM')(Date.now())])
          : undefined
        if (!isNil(current)) {
          setInvoice(current.status)
        }
      }
      getInvoice().finally(() => setLoading(false))
    }
  }, [subscription])

  return loading ? (
    <Loading />
  ) : hasError ? (
    <ServerError />
  ) : (
    <Box>
      {/* {isLoading ? <Loading /> : isAuthenticated ? <Outlet context={{ memberId, name, autoPayment }} /> : <UserAuthError />} */}
      <Container sx={{ pt: 5 }}>
        <Box component="form" sx={{ mt: 1 }}>
          <Stack spacing={3}>
            <Typography
              align="left"
              variant="h4"
              sx={{
                borderLeft: 20,
                borderBottom: 1,
                borderColor: 'orange',
                paddingLeft: 1
              }}>
              ご契約状況
            </Typography>
            <Typography variant="subtitle1">
              <Typography component={'span'} sx={{ ml: 1 }}>
                会員ID
              </Typography>
            </Typography>
            <Typography variant="subtitle2">{memberId}</Typography>
            <Typography variant="subtitle1">
              <Typography component={'span'} sx={{ ml: 1 }}>
                ご契約日
              </Typography>
            </Typography>
            <Typography variant="subtitle2">
              {!isEmpty(subscription?.demandStartDate)
                ? format('yyyy/M/d')(
                    parse(
                      Date.now(),
                      'yyyyMMdd'
                    )(subscription?.demandStartDate as string)
                  )
                : ''}
            </Typography>
            <Typography variant="subtitle1">
              <Typography component={'span'} sx={{ ml: 1 }}>
                ご契約者様
              </Typography>
            </Typography>
            <Typography variant="subtitle2">{`${subscription?.lastName} ${subscription?.firstName}`}</Typography>
            <Typography variant="subtitle1">
              <Typography component={'span'} sx={{ ml: 1 }}>
                サービス利用状況
              </Typography>
            </Typography>
            <Typography variant="subtitle2" color="warning">
              {subscription?.statusCd === SubscriptionStatus.inProgress
                ? 'ご利用中'
                : subscription?.statusCd ===
                  SubscriptionStatus.consentFormPrepared
                ? 'ご利用中'
                : subscription?.statusCd ===
                  SubscriptionStatus.consentFormRecieved
                ? 'ご利用中'
                : subscription?.statusCd ===
                  SubscriptionStatus.denkankyoConsentFailed
                ? 'ご利用中'
                : subscription?.statusCd === SubscriptionStatus.suspension
                ? 'ご利用停止中'
                : subscription?.statusCd === SubscriptionStatus.cancellation
                ? 'ご解約予定'
                : '-'}
            </Typography>
            {subscription?.statusCd === SubscriptionStatus.cancellation ? (
              <>
                <Typography variant="subtitle1">
                  <Typography component={'span'} sx={{ ml: 1 }}>
                    ご解約予定日
                  </Typography>
                </Typography>
                <Typography variant="subtitle2">
                  {!isNil(subscription?.cancellationDate)
                    ? subscription?.cancellationDate
                    : ''}
                </Typography>
              </>
            ) : (
              <></>
            )}
            <Typography variant="subtitle1">
              <Typography component={'span'} sx={{ ml: 1 }}>
                ご契約プラン
              </Typography>
            </Typography>
            <Typography variant="subtitle2">
              {!isEmpty(paymentSubscriptions) ? (
                <DispPaymentSubscriptions
                  paymentSubscriptions={paymentSubscriptions as string[]}
                />
              ) : (
                <></>
              )}
            </Typography>
            <Typography variant="subtitle1">
              <Typography component={'span'} sx={{ ml: 1 }}>
                当月お支払い
              </Typography>
            </Typography>
            <Typography variant="subtitle2">
              {invoice === EnumPaymentGmoPgStatus.Processed
                ? '決済完了'
                : invoice === EnumPaymentGmoPgStatus.Processing
                ? '決済処理中'
                : invoice === EnumPaymentGmoPgStatus.Error
                ? '決済失敗'
                : '-'}
            </Typography>
            {invoice === EnumPaymentGmoPgStatus.Error ? (
              <>
                <Divider sx={{ mt: 5, mb: 5 }} />
                <Typography variant="caption">
                  ※お支払いが「決済失敗」の場合、当月のサービスはご利用いただけません。
                  <br />
                  サービス再開をご希望される場合は、ご登録いただいたクレジットカードがご利用可能か確認いただき、
                  <Link href="/user/paymentEdit"> こちらから再登録 </Link>
                  してください。
                  <br />
                  翌月１日のお支払いが完了すると、翌月からサービスを再開いたします。
                  <br />
                </Typography>
              </>
            ) : (
              <></>
            )}
            {invoice === EnumPaymentGmoPgStatus.Error &&
            isWithinInterval({
              start: subDays(dispRepaymentStatDate)(startOfMonth(Date.now())),
              end: setDate(dispRepaymentEndDate)(Date.now())
            })(Date.now()) ? (
              <>
                ※有効なカードが登録された状態で、
                <Link href="/user/paymentEdit"> こちらから再決済 </Link>
                を行っていただくことで、当月の途中からサービスをご利用再開いただくことも可能です。
                ・再決済は当月15日まで実施可能です。
                <br />
                ・再決済でのお支払い完了後、サービスがご利用可能となるまで3営業日程度かかる場合がございます。予めご了承ください。
              </>
            ) : (
              <></>
            )}

            <Typography
              align="left"
              variant="h4"
              sx={{
                borderLeft: 20,
                borderBottom: 1,
                borderColor: 'orange',
                paddingLeft: 1
              }}>
              サービス解約について
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              サービス解約をご希望の方は、
              <Link
                href="https://terashite.zendesk.com/hc/ja/sections/4497724005273-%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B"
                target="_blank">
                {' '}
                こちら{' '}
              </Link>
              からお手続きが必要です。
              <br />
              ※連続して３ヶ月以上お支払いが無い場合、サービスを解約させていただくことがございます。
            </Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}
